import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { WhatsappTemplate } from 'src/app/models/notificacion/whatsapp_template.model';
import { Lista } from 'src/app/pages/base/lista';
import { WhatsappTemplateService } from 'src/app/services/notificacion/whatsapp_template.service';
import { XlsxService } from 'src/app/services/utils/xlsx.service';

@Component({
  selector: 'app-whatsapp-template-lista',
  templateUrl: './whatsapp-template-lista.component.html',
  styleUrls: ['./whatsapp-template-lista.component.scss']
})
export class WhatsappTemplateListaComponent extends Lista implements OnInit {

    constructor(
        public router: Router,
        public messageService: MessageService,
        public service: WhatsappTemplateService,
        private breadcrumbService: AppBreadcrumbService,
        private xlsxService: XlsxService
    ) { 
        super(router, messageService, service, WhatsappTemplate.CODIGO_MODULO, WhatsappTemplate.CODIGO_REGISTRO);
        this.breadcrumbService.setItems([{ label: 'Notificacion' }, { label: 'Plantillas de WhatsApp' }]);
        this.recordName = WhatsappTemplate.RECORD_NAME;
        this.name = WhatsappTemplate.NOMBRE_SINGULAR;
        this.pluralName = WhatsappTemplate.NOMBRE_PLURAL;
        this.navigate = [this.prefixPage, this.modulo, 'whatsapp-templates'];
        this.columns = [
            { field: 'nombre_empresa', label: 'Empresa', type: 'text', hidden: !this.currentUser.superusuario },
            { field: 'id', label: 'Id', type: 'id' },
            { field: 'fecha', label: 'Fecha', type: 'date' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'mensaje', label: 'Mensaje', type: 'text' },
            { field: 'estado', label: 'Estado', type: 'multiselect', options: WhatsappTemplate.ESTADOS },
            { field: 'activo', label: 'Activo', type: 'boolean' },
        ]
    }

    ngOnInit(): void {
    }

    async loadItems() {
        try {
            this.loading = true;
            const res = await this.service.getAll();
            if (res.ok) {
                this.items = (res.resp.rows || []).map((item: Record<string, any>) => ({
                    ...item,
                    estado: WhatsappTemplate.normalizarEstado(item.estado),
                    approve_status: WhatsappTemplate.normalizarApproveStatus(item.approve_status),
                }));
                this.totalRecords = res.resp.count;
            } else {
                this.messageService.add({ severity: 'error', summary: res.msg, detail: res.resp });
            }
            this.loading = false;
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout(() => {
                this.router.navigate(this.routerLogout);
            }, 4000);
        }
    }

}
